import $ from "jquery";
import BD_Question from "@bd-components/bd-question";

export class QuestionSlider extends BD_Question {
  constructor(...args) {
    super(...args);

    const sliderType = args[0].meta_data.slider_type;
    this.sliderType = sliderType;
    this.elms = {
      answer: ".js-answer",
      placeHolder: ".gameScreen",
      steps: ".js-onclick-steps",
      step: ".js-onclick-step",
      questionScreen: "",
    };

    if (this.sliderType === "number") {
      $(".slider__placeholder").css({
        visibility: "hidden",
        width: "99%",
      });
      $(
        ".slider__placeholder div:last-child, .slider__placeholder div:first-child"
      ).css({
        visibility: "visible",
      });
      $(".slider__step:not(:first-child):not(:last-child)").css({
        visibility: "hidden",
      });
    } else {
      $(".slider__thumb").css("display", "none");
    }

    this.initValue();
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "input",
        selector: elms.answer,
        handler: this.onSlidingAnswer.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "mouseover",
        selector: elms.answer,
        handler: this.mimicHover.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "mousedown",
        selector: elms.answer,
        handler: this.thumbHover.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "mouseup",
        selector: elms.answer,
        handler: this.thumbRelease.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "click",
        selector: elms.step,
        handler: this.onClickStep.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "mouseleave",
        selector: elms.answer,
        handler: this.thumbRelease.bind(this),
        isQuestionEvent: true,
      },
    ];
  }

  initValue(e) {
    this.onSlidingAnswer(e, $(this.elms.answer));
  }

  onSlidingAnswer(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".js-slider-indicator");
    const $bubble = $thumb.find(".slider__thumb-text");
    const $step = $parent.find(".js-onclick-step");
    const val = $el.val();
    const min = $el.prop("min");
    const max = $el.prop("max");
    const newVal = Number(((val - min) * 100) / (max - min));
    $bubble.html(val);
    $thumb.css("left", newVal + "%").addClass("is-transitioning");
    $step.removeClass("is-current");

    $step.each(function () {
      const $stepIndex = $(this).data("index");
      if ($stepIndex === parseInt(val)) {
        $(this).addClass("is-current");
      } else {
        $(this).removeClass("is-current");
      }
    });
    

    setTimeout(function () {
      $thumb.removeClass("is-transitioning");
    }, 400);
  }

  onClickStep(e, $el) {
    const val = $el.data("index");
    const $parent = $el.parents(".slider__input");
    const $inputSlider = $parent.find(".js-answer");
    $inputSlider.val(val);
    this.onSlidingAnswer(e, $inputSlider);
  }

  mimicHover(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".slider__point");
    const thumbLeft = $thumb.offset().left;
    const thumbWidth = 30;
    const maxLeft = (thumbLeft+thumbWidth);
    const x = window.event;
    // @ts-ignore
    const posX = x.clientX;

    if (posX <= maxLeft && posX >= thumbLeft) {
      $thumb.addClass("is-transitioning");
    } else {
      $thumb.removeClass("is-transitioning");
    }
  }

  thumbHover(e, $el) { 
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".js-slider-indicator");

    $thumb.addClass("is-transitioning");
  }

  thumbRelease(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".js-slider-indicator");

    $thumb.removeClass("is-transitioning");
  }

  getAnswer(ctx) {
    const index = parseInt($(".slider__item").val().toString());
    const answer = ctx._data.question.answers[index];
    return answer.id;
  }
}
